import React from 'react';
import { Alert } from '@edgebox/react-components';

export function MissingSiteAlert() {
  return (
    <Alert variant="warning">
      <h2>Missing site access</h2>
      <p>
        It looks like this page was loaded without access to a site. This is likely a technical issue with how the page was loaded. Please
        try reloading the page, and if the issue persists, contact support for assistance.
      </p>
    </Alert>
  );
}
